import isNil from 'lodash/isNil';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  ProviderEntryConfigDTO,
} from 'dtos';
import {
  getApiSettingsGetProviderEntryConfig,
} from 'endpoints';
import {
  normalizePhoneNumber,
} from 'pages/Dashboard/utils/helper';
import {
  getProviderEntryConfigLookup,
  getProviderEntryConfigQueryKey,
  ProviderEntryConfigTarget,
} from 'pages/Dashboard/components/ReferringProvider/providerEntryConfigTarget';

export function getEmptyProviderConfig(providerEntryId?: number): ProviderEntryConfigDTO {
  return {
    providerEntryId,
    isPinned: false,
    phoneNumber: { phoneNumberWithAreaCode: '' },
    faxNumber: '',
    email: '',
  };
}

export function normalizeProviderConfigPayload(
  formData: ProviderEntryConfigDTO,
  target: ProviderEntryConfigTarget,
): ProviderEntryConfigDTO {
  const normalizedPhone = normalizePhoneNumber(formData.phoneNumber?.phoneNumberWithAreaCode ?? '');
  const faxNumber = normalizePhoneNumber(formData.faxNumber ?? '');
  const email = notEmptyString(formData.email) ? formData.email : null;

  return {
    isPinned: formData.isPinned ?? false,
    ...(!isNil(formData.providerEntryConfigId)
      ? { providerEntryConfigId: formData.providerEntryConfigId }
      : {}),
    ...(target.kind === 'existing'
      ? { providerEntryId: target.providerEntryId }
      : { providerEntry: target.providerEntry }),
    ...(!isNil(normalizedPhone)
      ? { phoneNumber: { phoneNumberWithAreaCode: normalizedPhone } }
      : {}),
    ...(!isNil(faxNumber) ? { faxNumber } : {}),
    ...(!isNil(email) ? { email } : {}),
  };
}

export function getProviderEntryConfigQueryOptions(target: ProviderEntryConfigTarget | null) {
  const lookup = getProviderEntryConfigLookup(target);
  return {
    queryKey: getProviderEntryConfigQueryKey(target),
    queryFn: async (): Promise<ProviderEntryConfigDTO | null> => {
      if (lookup.kind === 'unavailable') {
        return getEmptyProviderConfig(target?.kind === 'existing' ? target.providerEntryId : undefined);
      }
      return getApiSettingsGetProviderEntryConfig(
        lookup.kind === 'providerEntryId'
          ? { providerEntryId: lookup.providerEntryId }
          : { npiNumber: lookup.npiNumber },
      );
    },
    enabled: lookup.kind !== 'unavailable',
  };
}
